import axios from 'axios';
import qs from 'qs'
import config from '../config'
const baseUrl = config.s2Url;
const smarketBaseApi = async (url, params) => {
    const res = await axios.request({
        url: url,
        method: 'post',
        headers: {
            'Content-type': 'application/json;charset=UTF-8'
        },
        baseURL: config.s2Url,
        data: params
    });
    return res.data.body;
};
const post = (url, data) => {
    //第三个参数用于配置请求参数
    return axios.post(baseUrl+url, data).then(response => {
        return response.data.body;
    }, error => {
        const res = {
            code: 404,
            msg: '请求超时'
        }
        return res;
    });
}
const get = (url, data) => axios.get(baseUrl+url, {params: data}).then(response => {
    return response.data.body;
}).catch(errors => {
    console.log(errors)
    const res = {
        code: 404,
        msg: '请求超时'
    }
    return res;
});
export {smarketBaseApi,post,get}
